module.exports = __webpack_public_path__ + "303ded6436dcf7ea75157e2aeff876ce.woff";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-Medium.woff
// module id = 348
// module chunks = 0